import { useForm } from "react-hook-form";
import { JVDropdown } from "../../shared/JVDropdown";
import { Button } from "primereact/button";
import { useEffect, useState } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { EmptyUserFilter, TUserFilter } from "./modal";
import { TDropdown } from "../../shared/modal";
import { Fetch } from "../../utilities/fetch";

interface IProps {
    filters: TUserFilter,
    setFilters: (filters: TUserFilter) => void,
    loading: boolean,
}

const schema = yup.object({
    branchId: yup.number().nullable(),
    roleId: yup.number().nullable(),
    status: yup.bool().nullable(),
    workFrom: yup.number().nullable(),
});

export const Filter = (props: IProps) => {
    const [branches, setBranches] = useState<TDropdown[]>();
    const [roles, setRoles] = useState<TDropdown[]>();
    const { control, handleSubmit, reset } = useForm<TUserFilter>({
        resolver: yupResolver(schema),
        defaultValues: props.filters,
        shouldFocusError: false
    });

    const Status = [
        { label: "--Select--", status: null },
        { label: "Active", status: true },
        { label: "Inactive", status: false }
    ];

    const WorkFrom = [
        { from: "--Select--", value: null },
        { from: "Onsite", value: 1 },
        { from: "Remote", value: 2 }
    ];

    const loadBranches = async () => {
        const data = await Fetch("Dropdown/branches");
        if (data) {
            setBranches(data);
        }
    }
    const loadRoles = async () => {
        const data = await Fetch("Dropdown/roles");
        if (data) {
            setRoles(data);
        }
    }

    useEffect(() => {
        loadBranches();
        loadRoles();
    }, []);

    const onSubmit = (data: TUserFilter) => {
        props.setFilters(data);
    }

    return (
        <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
            <JVDropdown column={6} label="Branch" control={control} name="branchId" options={branches} optionLabel="name" optionValue="id" placeholder="Select Branch" />
            <JVDropdown column={6} label="Role" control={control} name="roleId" options={roles} optionLabel="name" optionValue="id" placeholder="Select Role" />
            <JVDropdown column={6} control={control} label="Status" name="status" options={Status} optionLabel="label" optionValue="status" placeholder="Select Status" />
            <JVDropdown column={6} control={control} label="Work From" name="work_From" options={WorkFrom} optionLabel="from" optionValue="value" placeholder="Select Work From" />

            <div className="col-12 md:col-12" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', columnGap: '10px', marginTop: '10px' }}>
                <Button className="field col-12 md:col-6" label="SEARCH" type="submit" loading={props.loading}></Button>
                <Button className="field col-12 md:col-6 p-button-outlined" label="CLEAR" onClick={() => reset(EmptyUserFilter)} type="button"></Button>
            </div>
        </form>
    );
}